import type { AppFeatureToggles } from './modules/app-context';

export const defaultFeatures: AppFeatureToggles = {
  helpCenter: {
    enabled: true,
    supportEmail: 'customerservice@ethoca.com',
  },
};
